import { Specialty } from '../models/Specialist';

function getConcatNames(listNames: string[]) {
  let specialtiesTogether = '';
  listNames.map((name, index) => {
    if (specialtiesTogether.length && listNames.length !== index + 1)
      specialtiesTogether = `${specialtiesTogether}, ${name}`;
    if (specialtiesTogether.length === 0) specialtiesTogether = name;
    if (listNames.length === index + 1) specialtiesTogether = `${specialtiesTogether} e ${name}`;
    if (listNames.length === 1) specialtiesTogether = name;
  });

  return specialtiesTogether;
}

function getSpecialtyListName(specialties: Specialty[]) {
  const specialtiesTogether: string[] = [];
  specialties.map(item => {
    specialtiesTogether.push(item.name);
  });
  return specialtiesTogether;
}

function getSpecialtiesJoined(specialties: Specialty[]) {
  const specialtiesFiltered = specialties.filter(item => item.item_type === 'SPECIALTY');
  return getSpecialtyListName(specialtiesFiltered);
}

function getMedicalFieldJoined(specialties: Specialty[]) {
  const specialtiesFiltered = specialties.filter(item => item.item_type === 'MEDICAL_FIELD');
  return getSpecialtyListName(specialtiesFiltered);
}

function getMedicalExpertisesJoined(specialties: Specialty[]) {
  const specialtiesFiltered = specialties.filter(item => item.item_type === 'AREA_EXPERTISE');
  return getSpecialtyListName(specialtiesFiltered);
}

export function handleSpecialtiesWithExpertises(list: Specialty[]) {
  const specialties = getSpecialtiesJoined(list);
  const medicalFields = getMedicalFieldJoined(list);
  const expertises = getMedicalExpertisesJoined(list);
  const doctorSpecialties = specialties.concat(medicalFields, expertises);
  return getConcatNames(doctorSpecialties);
}
